import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

import discoverse3hd from 'assets/images/widget/consoles/Image_Microsite_Consoles_SE3HD.png';
import discoverse3hdxs from 'assets/images/widget/consoles/Image_Microsite_Consoles_SE3HD_XS.png';
import discoverse from 'assets/images/widget/consoles/Image_Microsite_Consoles_SE.png';
import discoversexs from 'assets/images/widget/consoles/Image_Microsite_Consoles_SE_XS.png';
import discoverse3 from 'assets/images/widget/consoles/Image_Microsite_Consoles_SE3.png';
import discoverse3xs from 'assets/images/widget/consoles/Image_Microsite_Consoles_SE3_XS.png';
import st from 'assets/images/widget/consoles/Image_Microsite_Consoles_ST.png';
import stxs from 'assets/images/widget/consoles/Image_Microsite_Consoles_ST_XS.png';
import c70t from 'assets/images/widget/consoles/Image_Microsite_Consoles_70T.png';
import c70txs from 'assets/images/widget/consoles/Image_Microsite_Consoles_70T_XS.png';

const useIcontyles = makeStyles({
    mainDiv: {
        "@media (max-width: 960px)": {
            textAlign: "center"
        }
    },
    mainDiv2: {
        "@media (max-width: 960px)": {
            textAlign: "left"
        }
    },
    iconImage: {
        "@media (max-width: 960px)": {
            height: '2em',
            margin: "0.2em"
        },
        "@media (min-width: 960px)": {
            height: '4em',
            margin: "0.5em"
        },
    },
    fullImage: {
        "@media (max-width: 960px)": {
            width: "60%"
        },
        "@media (min-width: 960px)": {
            width: '100%',
            padding: "1em"
        },
    },
    subtextLF: {
        fontSize: "1em",
        fontWeight: "bold",
        textAlign: "center",
        marginBottom: "0px",
        color: "#000"
    },
    subtextConsole: {
        fontSize: "1.2em",
        fontWeight: "bold",
        textAlign: "center",
        color: "#000"
    },
});

// * Icon for the LF Logo.

export default function ConsoleIcon(props) {
    const { consoleType, bigIcon, showText, ...rest } = props;
    const classes = useIcontyles();

    function getImage(consoleType) {
        switch (consoleType) {
            case 'Discover SE3 HD':
                {
                    if (bigIcon)
                        return discoverse3hd;
                    else
                        return discoverse3hdxs
                }
            case 'Discover SE3':
                {
                    if (bigIcon)
                        return discoverse3;
                    else
                        return discoverse3xs
                }
            case 'Discover SE':
                {
                    if (bigIcon)
                        return discoverse;
                    else
                        return discoversexs
                }
            case 'Discover SI':
                {
                    if (bigIcon)
                        return discoverse;
                    else
                        return discoversexs
                }
            case 'ST':
                {
                    if (bigIcon)
                        return st;
                    else
                        return stxs
                }
            case '70T':
                {
                    if (bigIcon)
                        return c70t;
                    else
                        return c70txs
                }
            case 'Integrity SL': return discoverse;
            default: return null;
        }
    }


    return (
        <div {...rest} className={bigIcon ? classes.mainDiv : classes.mainDiv2}>
            <img alt={consoleType} src={getImage(consoleType)} className={bigIcon ? classes.fullImage : classes.iconImage} />
            {showText ?
                <div>
                    <p className={classes.subtextLF}>Life Fitness</p>
                    <p className={classes.subtextConsole}>{consoleType}</p>
                </div>
                :
                null
            }
        </div>
    );
}

ConsoleIcon.propTypes = {
    consoleType: PropTypes.oneOf(['Discover SE3 HD', 'Discover SE3', 'Discover SE/SI', 'ST', '70T']),
    bigIcon: PropTypes.bool,
    showText: PropTypes.bool,
};